var map = {
	"./Library_0.png": 1287,
	"./Library_1.png": 1288,
	"./Library_2.png": 1289,
	"./Library_3.png": 1290,
	"./Library_4.png": 1291,
	"./Library_5.png": 1292,
	"./Library_6.png": 1293,
	"./Library_7.png": 1294
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1286;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library ^\.\/Library_.*\.png$
// module id = 1286
// module chunks = 3